export function _nextOrPrev(nextOrPreviousElementSibling, selector, element) {
    do {
        element = element[nextOrPreviousElementSibling];
    }while (element && !element.matches(selector));
    return element;
}
